import React, {FC, useState} from "react";
import {
    Button,
    Wrap,
    WrapItem,
} from "@chakra-ui/react";
import {
    FiHeadphones,
    FiMonitor,
    FiPrinter,
    FiSun,
    FiWifi,
    FiZap,
} from "react-icons/fi";
import {Amenity} from "@features/reservation/types";

const ICON_MAP: Record<string, React.ElementType> = {
    "screen": FiMonitor,
    "large-screen": FiMonitor,
    "monitor": FiMonitor,
    "headphone": FiHeadphones,
    "headphones": FiHeadphones,
    "power": FiZap,
    "power-outlet": FiZap,
    "stopcontact": FiZap,
    "window": FiSun,
    "wifi": FiWifi,
    "printer": FiPrinter,
};

interface AmenityFilterProps {
    amenities: Amenity[];
    onSelectionChange: (selectedIds: number[]) => void;
}

const AmenityFilter: FC<AmenityFilterProps> = ({amenities, onSelectionChange}) => {
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const toggle = (id: number) => {
        const next = selectedIds.includes(id)
            ? selectedIds.filter(x => x !== id)
            : [...selectedIds, id];
        setSelectedIds(next);
        onSelectionChange(next);
    };

    if (!amenities.length) return null;

    return (
        <Wrap spacing={"8px"}>
            {amenities.map((amenity: Amenity) => {
                const isSelected = selectedIds.includes(amenity.amenityTypeId);
                const IconComponent = amenity.iconKey ? ICON_MAP[amenity.iconKey] : undefined;
                return (
                    <WrapItem key={amenity.amenityTypeId}>
                        <Button
                            size={"sm"}
                            borderRadius={"full"}
                            leftIcon={IconComponent ? <IconComponent size={"14px"}/> : undefined}
                            bg={isSelected ? "custom.brand_primary" : "white"}
                            color={isSelected ? "white" : "custom.gray_700"}
                            borderWidth={"1px"}
                            borderColor={isSelected ? "custom.brand_primary" : "custom.gray_300"}
                            _hover={{
                                bg: isSelected ? "custom.brand_primary" : "custom.gray_100",
                            }}
                            onClick={() => toggle(amenity.amenityTypeId)}
                        >
                            {amenity.name}
                        </Button>
                    </WrapItem>
                );
            })}
        </Wrap>
    );
};

export default AmenityFilter;
